function umpInitAccordions(root) {
  root.querySelectorAll('.ump-accordion').forEach((accordion) => {
    if (accordion.dataset.umpAccordionInit) return;
    accordion.dataset.umpAccordionInit = '1';
    const items = accordion.querySelectorAll('.ump-accordion-item');
    items.forEach((item) => {
      const trigger = item.querySelector('.ump-accordion-trigger');
      if (!trigger) return;
      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        items.forEach((i) => {
          i.classList.remove('is-open');
          const t = i.querySelector('.ump-accordion-trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
}

function umpInitCarousels(root) {
  root.querySelectorAll('.ump-carousel').forEach((carousel) => {
    if (carousel.dataset.umpCarouselInit) return;
    carousel.dataset.umpCarouselInit = '1';
    const track = carousel.querySelector('.ump-wide-track');
    const cards = track ? Array.from(track.children) : [];
    const prevBtn = carousel.querySelector('.ump-carousel-prev');
    const nextBtn = carousel.querySelector('.ump-carousel-next');
    const dotsWrap = carousel.querySelector('.ump-carousel-dots');
    if (!track || cards.length === 0) return;

    const closestIndex = () => {
      const trackLeft = track.getBoundingClientRect().left;
      let closest = 0;
      let closestDist = Infinity;
      cards.forEach((card, i) => {
        const dist = Math.abs(card.getBoundingClientRect().left - trackLeft);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      });
      return closest;
    };

    const goTo = (index) => {
      const clamped = Math.max(0, Math.min(index, cards.length - 1));
      track.scrollTo({ left: cards[clamped].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
    };

    const next = () => {
      const current = closestIndex();
      goTo(current + 1 >= cards.length ? 0 : current + 1);
    };

    const prev = () => {
      const current = closestIndex();
      goTo(current - 1 < 0 ? cards.length - 1 : current - 1);
    };

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    if (dotsWrap) {
      cards.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ump-carousel-dot';
        dot.setAttribute('aria-label', 'Go to card ' + (i + 1));
        dot.addEventListener('click', () => goTo(i));
        dotsWrap.appendChild(dot);
      });
      const updateDots = () => {
        const active = closestIndex();
        dotsWrap.querySelectorAll('.ump-carousel-dot').forEach((dot, i) => {
          dot.classList.toggle('is-active', i === active);
        });
      };
      track.addEventListener('scroll', () => window.requestAnimationFrame(updateDots));
      updateDots();
    }

    if (carousel.dataset.autoplay === 'true') {
      const speed = parseInt(carousel.dataset.autoplaySpeed, 10) || 4000;
      let timer = setInterval(next, speed);
      const stop = () => clearInterval(timer);
      const start = () => { clearInterval(timer); timer = setInterval(next, speed); };
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);
    }
  });
}

function umpInitGalleries(root) {
  root.querySelectorAll('.ummi-prod-main-img').forEach((mainImg) => {
    if (mainImg.dataset.galInit) return;
    mainImg.dataset.galInit = '1';

    const container = mainImg.closest('.ummi-prod-gallery') || mainImg.parentElement;
    const slides = Array.from(mainImg.querySelectorAll('.ummi-gallery-slide'));
    const thumbs = Array.from(container ? container.querySelectorAll('.ummi-prod-thumb') : []);
    const prevBtn = mainImg.querySelector('.ummi-gallery-prev');
    const nextBtn = mainImg.querySelector('.ummi-gallery-next');
    if (!slides.length) return;

    let current = 0;

    function goTo(index) {
      current = ((index % slides.length) + slides.length) % slides.length;
      slides.forEach((s, i) => s.classList.toggle('active', i === current));
      thumbs.forEach((t, i) => t.classList.toggle('active', i === current));
    }

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(parseInt(t.dataset.index, 10))));
  });
}

function umpInitReviewCarousel(root) {
  root.querySelectorAll('[data-review-strip]').forEach((strip) => {
    if (strip.dataset.reviewInit) return;
    strip.dataset.reviewInit = '1';

    const track = strip.querySelector('.ummi-review-track');
    const prevBtn = strip.querySelector('.ummi-review-arrow--prev');
    const nextBtn = strip.querySelector('.ummi-review-arrow--next');
    const total = parseInt(strip.dataset.total, 10) || 0;
    if (!track || total < 2) return;

    let current = 0;
    let timer = setInterval(advance, 4000);

    function goTo(index) {
      current = ((index % total) + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
    }

    function advance() { goTo(current + 1); }

    function nav(dir) {
      goTo(current + dir);
      clearInterval(timer);
      timer = setInterval(advance, 4000);
    }

    if (prevBtn) prevBtn.addEventListener('click', () => nav(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => nav(1));
  });
}

function umpInitUGCSound(root) {
  root.querySelectorAll('.ump-ugc-sound-btn').forEach((btn) => {
    if (btn.dataset.soundInit) return;
    btn.dataset.soundInit = '1';
    btn.addEventListener('click', () => {
      const video = btn.closest('.ump-social-tile').querySelector('video');
      if (!video) return;
      const willUnmute = video.muted;
      // mute all videos and reset all buttons
      document.querySelectorAll('.ump-social-tile video').forEach((v) => {
        v.muted = true;
        v.setAttribute('muted', '');
      });
      document.querySelectorAll('.ump-ugc-sound-btn').forEach((b) => b.classList.remove('is-live'));
      // toggle: if this video was muted, unmute it
      if (willUnmute) {
        video.muted = false;
        video.removeAttribute('muted');
        video.play();
        btn.classList.add('is-live');
      }
    });
  });
}

function umpInitQty(root) {
  root.querySelectorAll('.ummi-qty-box').forEach((box) => {
    if (box.dataset.qtyInit) return;
    box.dataset.qtyInit = '1';
    const display = box.querySelector('.ummi-qty-num');
    const sectionId = box.dataset.sectionId;
    const input = sectionId ? document.getElementById('UmmiQtyInput-' + sectionId) : null;
    let qty = 1;
    const [decBtn, incBtn] = box.querySelectorAll('.ummi-qty-btn');
    function update(delta) {
      qty = Math.max(1, qty + delta);
      if (display) display.textContent = qty;
      if (input) input.value = qty;
    }
    if (decBtn) decBtn.addEventListener('click', () => update(-1));
    if (incBtn) incBtn.addEventListener('click', () => update(1));
  });
}

function umpInit(root) {
  umpInitAccordions(root);
  umpInitCarousels(root);
  umpInitGalleries(root);
  umpInitQty(root);
  umpInitReviewCarousel(root);
  umpInitUGCSound(root);
}

document.addEventListener('DOMContentLoaded', () => umpInit(document));
document.addEventListener('shopify:section:load', (e) => umpInit(e.target));
